export const LoadingDotsVariants = Object.freeze({
    Accent: 'accent',
    Gradient: 'gradient'
});

export type LoadingDotsVariant = (typeof LoadingDotsVariants)[keyof typeof LoadingDotsVariants];
